import type { BoxProps } from '@chakra-ui/react';
import { Box, Flex, Image } from '@chakra-ui/react';
import type { ReactNode } from 'react';
import React, { useMemo } from 'react';

import type { StakeableNft } from '../types';
import { useGardenNftDrawerStore } from './useGardenNftDrawer';

type SelectedNftPreviewProps = {
  nfts: StakeableNft[];
  nSelectable: number;
  renderAdditionalContent?: (nft?: StakeableNft) => ReactNode;
  onClickNft?: (nft: StakeableNft) => void;
} & BoxProps;

const SelectedNftPreview: React.FC<SelectedNftPreviewProps> = ({
  nfts: cruisers,
  nSelectable,
  renderAdditionalContent,
  onClickNft,
  ...boxProps
}) => {
  const selectedTokens = useGardenNftDrawerStore((s) => s.selectedTokens);
  const selectedNfts = useMemo(
    () =>
      selectedTokens
        .map((token) => cruisers?.find((c) => c.id === token.id))
        .filter((c) => c),
    [selectedTokens, cruisers],
  );

  return (
    <Box px={4} maxW="375px" mb={5} mx="auto" {...boxProps}>
      <Flex gap="30px" justifyContent="center">
        {Array.from({ length: nSelectable }).map((_, i) => {
          const nft = i < selectedNfts.length ? selectedNfts[i] : undefined;
          return (
            <Flex
              flexDir="column"
              key={i}
              align="center"
              cursor={onClickNft ? 'pointer' : 'default'}
              onClick={() => onClickNft && nft && onClickNft(nft)}
            >
              <StakePreviewCard cruiser={nft} />
              <Box>
                {renderAdditionalContent && renderAdditionalContent(nft)}
              </Box>
            </Flex>
          );
        })}
      </Flex>
    </Box>
  );
};

type StakePreviewCardProps = {
  cruiser?: {
    name: string;
    imageUrl: string;
  };
};

const StakePreviewCard: React.FC<StakePreviewCardProps> = ({ cruiser }) => {
  return (
    <Flex
      w="45px"
      h="45px"
      borderColor="text.normal"
      borderRadius="4px"
      borderWidth={cruiser ? undefined : '1px'}
      borderStyle={cruiser ? undefined : 'dashed'}
      justify="center"
      align="center"
    >
      {cruiser && (
        <Image
          rounded="4px"
          w="full"
          h="full"
          src={cruiser.imageUrl}
          alt={cruiser.name}
        />
      )}
      {!cruiser && <Image w="17px" src="/images/helper.svg" alt="employ" />}
    </Flex>
  );
};

export default SelectedNftPreview;
